import { put, select } from 'redux-saga/effects';

import { debug } from '../utils/logger';

import { userAgreedToCookies, useGocatss } from '../actions/cookiesAlertActions';
import { getParameterByName } from '../utils';
import { chooseSiteId } from '../utils/cookieUtils';
import Cookies from '../services/cookies';

import {
    COOKIE_NAME_HAS_ACCEPTED_COOKIES,
    COOKIE_NAME_IS_WEBVIEW,
    COOKIE_NAME_USE_SEARCH_PROVIDER
} from '../constants';

export function* cookieSaga() {
    debug('Saga: cookieSaga initialized');
    const state = yield select();
    const hasAgreedToCookies = Boolean(Cookies.getCookieByName(COOKIE_NAME_HAS_ACCEPTED_COOKIES));
    const gocatssIsActive = Cookies.getCookieByName(COOKIE_NAME_USE_SEARCH_PROVIDER) === 'gocatss';
    const gocatssDebuggerIsActive = gocatssIsActive && _.get(state, 'core.constants.gocatssDebugger', false);

    if(gocatssIsActive) {
        yield put(useGocatss(gocatssIsActive, gocatssDebuggerIsActive));
    }

    const siteReferrer = getParameterByName('ref');
    const isWebView = getParameterByName('webview');

    if (siteReferrer && siteReferrer === 'footer' || siteReferrer === 'languageSelect') {
        chooseSiteId(state.core.siteId, state.core.siteId);
    }

    if (isWebView && isWebView === 'true') {
        Cookies.setCookie(COOKIE_NAME_IS_WEBVIEW, 'true');
    }

    yield put(userAgreedToCookies(hasAgreedToCookies));
}

export default [cookieSaga];
